const OIDCOptions = {
	// paths to UMD login servers
	authorityUrls: {
		local: 'https://login-dev.dts.utah.gov',
		dev: 'https://login-dev.dts.utah.gov',
		at: 'https://login-at.dts.utah.gov',
		prod: 'https://login.dts.utah.gov',
	},

	loginUrl: () => `${OIDCOptions.currentAuthority()}:443/sso/oauth2`,
	logoutUrl: returnUrl => `${OIDCOptions.currentAuthority()}/sso/UI/Logout?goto=${returnUrl || document.location.origin}`,

	automaticSilentRenew: true,

	// client_id is generatd by apadmin to identify the application - must be set before constructing OIDCCore component (see App.jsx: oidcOptions.client_id = 'feta-Megapodidae-628443')
	client_id: undefined,

	// authority based on current location - Dev apadmin is slow to sync (one hour delay), so can use prod until dev turns on; note that logoff doesn't really logoff always in Dev
	currentAuthority: () => (
		// OIDCOptions.authorityUrls.prod ||
		(document.location.hostname.includes('localhost') ? OIDCOptions.authorityUrls.local
		: document.location.hostname.includes('.dev.') ? OIDCOptions.authorityUrls.dev
			: document.location.hostname.includes('.at.') ? OIDCOptions.authorityUrls.at
				: OIDCOptions.authorityUrls.prod)
	),

	filterProtocolClaims: false,

	loadUserInfo: true,

	// paths that OIDC Core uses for login/logout/slientRenew
	paths: {
		// tell where to go to login user: must be an entry in apadmin
		loginCallback: () => `${OIDCOptions.oidcSecuredPaths[0]}/login/callback`,
		// tell where to go to logout user: must be an entry in apadmin
		logout: () => `${OIDCOptions.oidcSecuredPaths[0]}/logout`,
		// refreshes token behind the scenes: must be an entry in apadmin?
		silentRenew: () => `${OIDCOptions.oidcSecuredPaths[0]}/silentRenew`,
	},

	// tells path in the redux store should the oidc user be stored
	reduxUserPath: 'oidc.user',

	// response that OpenId will return
	responseType: 'id_token token',

	// base React-Router path for securing content for the app
	oidcSecuredPaths: ['/secured'],

	// scopes to get from openId provider - matches "scopes" section of ApAdmin
	scope: 'openid profile email directory',

	// add context to a url - helpful for adding context to oidcOptions.paths
	urlWithContext: url => `${window.location.origin}${url}`,
};

export default OIDCOptions;
